import React from "react";
import { FaArrowLeft, FaSyncAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "../css/AppHeader.module.css";

export default function AppHeader({
  title = "",
  showBack = true,
  showRefresh = false,
  onRefresh,
  refreshing = false,
  rightContent = null,
  rightIcon = null,
  onRightIconClick = null,
  style = {},
  className = "",
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={`${styles.appHeader} ${className}`} style={style}>
      <div className={styles.headerContent}>
        {showBack && (
          <span
            className={styles.iconButton}
            onClick={() => navigate(-1)}
            tabIndex={0}
            aria-label={t("AppHeader.back", "Go back")}
          >
            <FaArrowLeft size={16} color="#000" />
          </span>
        )}
        <div className={styles.title}>
          {t(title, title)}
        </div>
        {showRefresh && (
          <button
            onClick={onRefresh}
            disabled={refreshing}
            aria-label={t("Common.refresh")}
            className={styles.refreshButton}
          >
            <FaSyncAlt
              size={13}
              className={refreshing ? styles.refreshIconSpinning : styles.refreshIcon}
            />
          </button>
        )}
        {rightIcon && (
          <span
            className={`${styles.iconButton} ${styles.rightIcon}`}
            onClick={onRightIconClick}
            tabIndex={0}
            aria-label="Action"
          >
            {React.cloneElement(rightIcon, { color: "#000" })}
          </span>
        )}
        {rightContent}
      </div>
    </div>
  );
}